<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.LogisticsPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="LogisticsPopup"
      class="logistics-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <van-field clickable name="datetimePicker" :value="form.operatingTime" label="操作时间" placeholder="点击选择时间" @click="showPickerDate = true">
          <template #right-icon>
            <span class="checkList">选择</span>
          </template>
        </van-field>
        <wh-staff
          v-model="form.staffName"
          style="padding:0;"
          lable="操作人"
          name="操作人"
          :rules="[{required:true,message: '请选择操作人'}]"
        />
        <van-field
          v-model="form.receiver"
          label="收件人"
          name="收件人"
          placeholder="请输入收件人"
          :rules="[{required:true,message: '请输入收件人'}]"
        />
        <van-field
          v-model="form.contactPhone"
          label="联系方式"
          name="联系方式"
          placeholder="请输入联系方式"
          :rules="[{required:true,message: '请输入联系方式'}]"
        />
        <van-field
          v-model="form.receiptAddress"
          label="收货地址"
          name="收货地址"
          placeholder="请输入收货地址"
          :rules="[{required:true,message: '请输入收货地址'}]"
        />
        <wh-popup-select
          v-model="form.packingId"
          style="background:#fff"
          :columns="goodsList"
          label="库存商品"
          name="库存商品"
          :rules="[{required:true,message: '请选择库存商品'}]"
        >
          <template slot="right-icon">
            <span class="checkList">选择</span>
          </template>
        </wh-popup-select>
        <van-field v-model="form.remarks" label="备注" placeholder="请输入备注" />
        <div style="padding:10px 16px;background:#fff">
          <wh-upload v-model="form.photo" :files-str.sync="photoStr" :max-count="3" />
        </div>
      </div>
      <van-popup v-model="showPickerDate" position="bottom">
        <van-datetime-picker type="datetime" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/convert/convertTime'
import WhPopup from '@/components/public/WhPopup/WhPopup.vue'
import WhUpload from '@/components/public/WhUpload/WhUpload'
import { formPopup } from '@/utils/mixins/formPopup'
import WhStaff from '@/components/public/WhStaff/WhStaff'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
export default {
  name: 'LogisticsPopup',
  components: { WhPopup, WhStaff, WhPopupSelect, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      showPickerDate: false,
      form: {
        id: undefined,
        operatingTime: this.formatTime(new Date(), 'YYYY-MM-DD HH:mm:00'),
        staffName: '',
        receiver: '',
        contactPhone: '',
        receiptAddress: '',
        packingId: undefined,
        remarks: '',
        photo: []
      },
      photoStr: '',
      goodsList: []
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增物流' : '编辑物流'
    }
  },
  watch: {
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.LogisticsPopup.resetValidation()
        })
      }
    }
  },
  methods: {
    formatTime,
    getGoodsList() {
      this.goodsList = []
      api.getPackingManagement().then(res => {
        res.data.list.map(i => {
          this.goodsList.push({
            text: i.productName,
            value: i.id
          })
        })
      })
    },
    onConfirm(date) {
      this.form.operatingTime = formatTime(date, 'YYYY-MM-DD HH:mm:00')
      this.showPickerDate = false
    },
    open() {
      this.getGoodsList()
      if (this.formType === 'create') {
        this.formDataInit(this.form, {
          operatingTime: this.formatTime(new Date(), 'YYYY-MM-DD HH:mm:00')
        })
      } else {
        this.initFormData.operatingTime = formatTime(this.initFormData.operatingTime, 'YYYY-MM-DD HH:mm:00')
        this.formDataInit(this.form, this.initFormData)
      }
    },
    submitForm() {
      if (this.form.id) {
        const editform = {
          ...this.form,
          photo: this.photoStr
        }
        api.updateLogisticsManagement(editform).then(() => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      } else {
        const createform = {
          ...this.form,
          photo: this.photoStr
        }
        api.createLogisticsManagement(createform).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.logistics-popup{
  min-height: calc(100% - 90px);
  background-color: #F6F5F5;
   .checkList{
    width: 35px;
    font-size: 14px;
    color: #20CAA0;
  }
  .main{
    padding: 6px 0;
  }
}

</style>
